<template>
    <mbs-scrollBar class="menu-wapper">
         <ul class="menu-first__ul" >
                <!-- 一级菜单 -->
                <li   v-for="(item,index) in menuList" :key="index" class="menu-first__li">
                    <div class="menu-first__title"   @click="handleFirst(item)"  :class="{'active': item.path === curPath}" >
                        <span class="menu-first__text">{{item.meta.title}}</span>
                    </div>
                    <template v-if="item.children.length !== 0">
                        <!-- 二级菜单 -->
                        <ul class="menu-second__ul">
                            <li
                                v-for="(child,cindex) in item.children"
                                @click="handleSecond(child)"
                                :key="cindex"
                                :class="{'active': child.path === curPath, 'special': child.meta.special}"
                                class="menu-second__li" >
                                    <icon-font v-if="child.meta.icon" :type="child.meta.icon" class="iconfont menu-second__icon"></icon-font>
                                    <i v-else class="menu-second__icon"></i>
                                     <span class="menu-second__text">{{child.meta.title}}</span>
                                </li>
                        </ul>
                    </template>
                </li>
        </ul>
    </mbs-scrollBar>
</template>

<script>
import { filterRouter } from './utils';
import MbsScrollBar from '../scroll-bar/ScrollBar.vue';

export default {
  name: 'mbsMenuDeep',
  components: {
    MbsScrollBar,
  },
  props: {
    menuListData: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  computed: {
    menuList() {
      return filterRouter(this.menuListData);
    },
    curPath() {
      return this.$route.path;
    },
  },
  methods: {
    handleFirst() {
      // 有二级菜单，则无任何交互
      // if (item.children && item.children.length !== 0) {return}
      // this.$router.push({name:item.name})
    },
    handleSecond(item) {
      // 点击的是当前菜单，则无任何交互
      if (this.curPath === item.path) return;
      this.$router.push({ name: item.name });
    },
  },
};
</script>

<style lang="less">
.menu {
    &-wapper {
        // overflow-y: auto;
        position: relative;
        overflow: hidden;
        padding-top: 20px;
        width: 180px;
        height: 100%;
        background-color: #f5f7fa;
        ul {
            margin: 0;
            padding: 0;
        }
        li {
            list-style: none;
            cursor: pointer;
        }
    }
    // 一级菜单
    &-first {
        &__ul {
            font-family: PingFangSC-Semibold;
            font-size: 14px;
            letter-spacing: -0.25px;
            color: rgba(0,0,0,0.65);
        }
        &__title {
            padding: 10px 0;
            padding-left: 20px;
            font-size:14px;
            font-family:PingFangSC-Regular,PingFang SC;
            color:rgba(0,0,0,0.45);
            line-height:20px;
            text-align: left;
            &:hover, &.active {
                color: #178FFF;
            }
        }
        &__text {
            font-weight:400;
        }
    }
    // 二级菜单
    &-second {
        &__ul {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: rgba(0,0,0,0.45);
            text-align: justify;
        }
        &__li {
            padding: 14px 0;
            padding-left: 22px;
            text-align: left;
            color:rgba(0,0,0,0.65);
            &:hover {
              background: #E9ECF1;
            }
            &.active {
              color: #178FFF;
              .anticon {
                color: inherit;
              }
            }
            &.special {
              width: 140px;
              height: 36px;
              border: 1px dashed #C6CAD1;
              text-align: center;
              margin: auto;
              padding: 0;
              line-height: 36px;
            }
            .anticon {
              color: #C6CAD1;
            }
        }
        &__icon {
            display: inline-block;
            margin-right: 10px;
            min-width: 16px;

        }

         &__text {
             text-align: left;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            line-height:20px;
        }
    }
}
</style>
